var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaintBrush = function SvgPaintBrush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PaintBrush_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PaintBrush_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.833 11.667a2.497 2.497 0 0 0-2.5 2.5c0 1.092-.966 1.667-1.666 1.667C2.433 16.85 3.742 17.5 5 17.5a3.33 3.33 0 0 0 3.333-3.333c0-1.383-1.116-2.5-2.5-2.5m11.425-7.809-1.116-1.116a.83.83 0 0 0-1.175 0L7.5 10.209 9.792 12.5l7.466-7.467a.83.83 0 0 0 0-1.175"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PaintBrush_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PaintBrush_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPaintBrush;